exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-35529c6b]{text-align:center;color:#333}a[data-v-35529c6b]{display:block;text-decoration:none}.item[data-v-35529c6b]{padding:2rem 3rem;margin:1rem 0;box-shadow:0 2px 16px 0 rgba(0,0,0,.04);background:#fff;text-align:center;color:#333;cursor:pointer;border-radius:5px}.item img[data-v-35529c6b]{width:70px;height:70px;margin-right:1.4rem;display:block;padding:.5rem}.item h3[data-v-35529c6b]{font-weight:700}@media only screen and (max-width:768px){.item[data-v-35529c6b]{padding:.5rem 1rem;margin:.5rem 0;min-height:110px;text-align:left}.top img[data-v-35529c6b]{width:150px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35529c6b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/List.vue
// module id = 78
// module chunks = 0